import React from 'react';
import classnames from 'classnames';
import { CircularProgress } from '@material-ui/core';
import * as Styles from './financing-loader.less';

interface Props {
    centerPage?: boolean;
}

export const FinancingLoader: React.FC<Props> = ({ centerPage }) => (
    <div className={Styles.fullHeight}>
        <CircularProgress
            size="large"
            className={classnames([
                Styles.spinner,
                { [Styles.centerPage]: centerPage },
            ])}
        />
        <div className={Styles.loadingMessage}>Processing...thank you for your patience.</div>
    </div>
);
